import IconMessageSolid from '@/assets/icons/font_awesome/message-solid.svg?react';
import { UI_PRIMITIVE__dropdown_menu_item } from '@/components/ui/dropdown/UI_PRIMITIVE__dropdown_menu_item';
import { toast, useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { cn } from '@/utils/utils_client';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormHelpMessage } from './FormHelpMessage';

export const ButtonHelpWriteMessage: FC = () => {
  /*
   * FIELDS
   */
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);
  const { dismiss } = useToast();

  /*
   * EVENTS
   */

  function on_item_selected() {
    let toast_data = toast({
      title: t(i18n_base_ui.toasts.send_message.title),
      action: <FormHelpMessage close_toast={() => dismiss(toast_data.id)} />,
      duration: Infinity,
    });
  }

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__dropdown_menu_item
      value="write_message"
      class_name_hovered_selected="bg-component-item-selected"
      {...{ on_item_selected }}
      className={cn('gap-2 p-2 cursor-pointer')}
    >
      <IconMessageSolid className="!text-bar-foreground size-5" />
      {t(i18n_base_ui.dropdown.help.button.help_write_message.title)}
    </UI_PRIMITIVE__dropdown_menu_item>
  );
};
